const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL
  ? process.env.REACT_APP_BACKEND_API_URL
  : "https://api.shippy.app";
const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL
  ? process.env.REACT_APP_FRONTEND_URL
  : "https://shippy.app";

console.log("BACKEND_API_URL", process.env);
export { BACKEND_API_URL, FRONTEND_URL };
